export default {
  getVehiclePart: (state) => state.vehiclePart,
};
